import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { Store } from '@ngrx/store';
import { LabelSelectors } from 'projects/semeris/src/store/label/label.selectors';
import { switchMap, take } from 'rxjs/operators';

import { LabelCategories } from '../../../label/constants/label-categories';
import { ButtonDirective } from '../../../ui/button/button/button.directive';
import { ConversationService } from '../../services/conversation.service';

@Component({
  selector: 'semeris-comment-customer-feedback',
  imports: [MatIconModule, ButtonDirective],
  templateUrl: './comment-customer-feedback.component.html',
  styleUrls: ['./comment-customer-feedback.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentCustomerFeedbackComponent {
  private readonly store = inject(Store);
  private readonly conversationService = inject(ConversationService);

  public readonly conversationId = input<string>(undefined);

  public feedbackSent = false;

  public onFeedbackClick(feedback: string): void {
    this.store
      .select(LabelSelectors.labels)
      .pipe(
        take(1),
        switchMap((labels) => {
          const label = labels.find(
            (l) =>
              l.category === LabelCategories.HelpAiFeedback &&
              l.displayName.toLocaleLowerCase() === feedback.toLocaleLowerCase()
          );

          this.feedbackSent = true;

          return this.conversationService.rateConversation(this.conversationId(), label.id);
        })
      )
      .subscribe();
  }
}
